import { Outlet, useLocation } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from './store/hooks/Redux'
import {
  hideAlert,
  hideModal,
  selectAlerts,
  selectModals,
  setLocation,
} from './store/reducers/AppSlice'
import { BpAlert } from './shared/components/cards/alert/BpAlert'
import { BpModal } from './shared/components/cards/modal/BpModal'
import { useEffect, useState } from 'react'
import { useOutsideClick } from './shared/hooks/UseOutsideClick'
import { useCookies } from 'react-cookie'
import Highcharts from 'highcharts'
import { getBaseDomain } from './shared/helpers/GetBaseDomain'

function App() {
  const dispatch = useAppDispatch()
  const [cookies, setCookie] = useCookies(['referer'])
  const alerts = useAppSelector(selectAlerts)
  const modals = useAppSelector(selectModals)
  const location = useLocation()
  const body = document.querySelector('body')
  const [isShowAlerts, setIsShowAlerts] = useState<boolean>(true)
  const clickRef = useOutsideClick(() => {
    if (alerts.length) setIsShowAlerts(false)
  })

  useEffect(() => {
    if (body && modals?.length) {
      body.style.overflow = 'hidden'
    } else if (body) {
      body.style.overflow = 'auto'
    }
  }, [modals])

  useEffect(() => {
    dispatch(setLocation(location))
  }, [location])

  useEffect(() => {
    const hostname = window.location.hostname
    const referer = document.referrer

    if (referer) {
      const decoded = decodeURIComponent(referer)
      const url = new URL(decoded)

      if (url.host.includes(process.env.REACT_APP_PROJECT as string)) return

      setCookie('referer', referer, {
        path: '/',
        domain: `.${getBaseDomain(hostname)}`,
        maxAge: 86400,
      })
    }
  }, [cookies, setCookie])

  Highcharts.setOptions({
    time: {
      timezoneOffset: 3 * 60,
      useUTC: true,
    },
  })

  return (
    <>
      {alerts && (
        <div
          ref={clickRef}
          className='fixed right-0 top-0 md:right-5 md:top-5 z-50 max-w-full md:max-w-[320px] flex flex-col gap-[10px]'
        >
          {alerts.map((alert, index: number) => (
            <BpAlert
              {...alert}
              key={index}
              show={isShowAlerts}
              onAfterClose={() => {
                dispatch(hideAlert(alert.message))
                setIsShowAlerts(true)
              }}
            />
          ))}
        </div>
      )}
      {modals?.map(
        (modal, index) =>
          modal?.children && (
            <BpModal
              key={index}
              id={modal.id}
              layer={index + 1}
              scroll={modal.scroll}
              size={modal.size}
              width={modal.width}
              onClose={() => dispatch(hideModal())}
            >
              {modal.children}
            </BpModal>
          ),
      )}
      <Outlet />
    </>
  )
}

export default App
